import { render } from "./RfmAnalysis.vue?vue&type=template&id=076630d3&scoped=true"
import script from "./RfmAnalysis.vue?vue&type=script&lang=js"
export * from "./RfmAnalysis.vue?vue&type=script&lang=js"

import "./RfmAnalysis.vue?vue&type=style&index=0&id=076630d3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076630d3"]])

export default __exports__